export const COLORS = {
  blue: '#4b50fa',
  black: '#141414',
  white: '#ffffff',
  gray: '#f5f5f5',
  red: '#ff5151',
  orange: '#ffb480',
  gray2: '#d7d7d7',
  green: '#0a3232',
};
